module.exports = __webpack_public_path__ + "img/3.374d2c72.png";